<g>
    <!-- Türblatt -->
    <rect style="stroke:#000;stroke-width:2;fill:#fccb00;" width="80" height="140" x="0" y="0"/>

    <!-- Türklinke -->
    <rect style="fill:#000" width="16" height="3" x="55" y="60"/>
    <circle cx="70" cy="70" r="3" fill="#000" />
</g>